export enum AssetType {
Fixed,
RealEstateBuilding,
Intangible,
RealEstateLand,
UnderConstruction,
}
